import { useSelector } from 'react-redux';

import { AppState } from '../../../../infra/store';
import { UseLoadingReturn } from '../types';

/**
 * Custom hook to access loading state from Redux
 *
 * @returns {UseLoadingReturn} Object containing isLoading and loadingText
 */
export const useLoading = (): UseLoadingReturn => {
  const isLoading = useSelector((state: AppState) => state.loadingReducer.isLoading);
  const loadingText = useSelector((state: AppState) => state.loadingReducer.loadingText);

  return {
    isLoading,
    loadingText
  };
};
